(function () {
  function initSection(event) {
    window.RotaTheme?.init(event.target);
  }

  function destroySection(event) {
    window.RotaTheme?.destroy(event.target);
  }

  function dispatchSelection(eventName, event) {
    event.target.dispatchEvent(
      new CustomEvent(eventName, {
        bubbles: true,
        detail: event.detail,
      })
    );
  }

  document.addEventListener('shopify:section:load', initSection);
  document.addEventListener('shopify:section:unload', destroySection);
  document.addEventListener('shopify:section:select', (event) => dispatchSelection('rm:section:select', event));
  document.addEventListener('shopify:section:deselect', (event) => dispatchSelection('rm:section:deselect', event));
  document.addEventListener('shopify:block:select', (event) => dispatchSelection('rm:block:select', event));
  document.addEventListener('shopify:block:deselect', (event) => dispatchSelection('rm:block:deselect', event));
})();
